import { useQuery } from '@tanstack/react-query';

import { Query } from './api';

export const useOAuthAuthorize = (accountId, integrationId) => {
  return useQuery({
    queryKey: [accountId, integrationId, 'oauth'],
    queryFn: async () => {
      return await new Query(
        `accounts/${accountId}/integrations/${integrationId}/oauth/authorize?redirect_path=${window.location.pathname}`,
      ).run();
    },
    staleTime: 10,
    enabled: !!integrationId,
  });
};
